import React from 'react';
import { ChevronDown } from 'lucide-react';

interface Props {
  open: boolean;
  onChange: (open: boolean) => void;
  /** The words while closed and while open; the default is "Show details" / "Hide details". */
  showLabel?: string;
  hideLabel?: string;
  /** The id of what it opens, for screen readers. */
  controls?: string;
  className?: string;
}

// The one control that turns a page from its headline into everything on it. Pages keep the choice in the
// address with hooks/useDetails.
export default function DetailsToggle({ open, onChange, showLabel = 'Show details', hideLabel = 'Hide details', controls, className = '' }: Props) {
  return (
    <button
      type="button"
      onClick={() => onChange(!open)}
      aria-expanded={open}
      aria-controls={controls}
      className={`inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-medium text-blue-700 ring-1 ring-inset ring-blue-200 transition-colors hover:bg-blue-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 motion-reduce:transition-none ${className}`}
    >
      {open ? hideLabel : showLabel}
      <ChevronDown className={`h-4 w-4 transition-transform motion-reduce:transition-none ${open ? 'rotate-180' : ''}`} aria-hidden />
    </button>
  );
}
